/* Rebuy Smart Cart -> theme cart-icon bridge.
   NOTE ON THE FILENAME: historical. This file also used to dedupe the Rebuy drawer's
   line-item frequency <select>, which listed every frequency twice because the sheet
   products sat in the packs' selling plan groups. On 2026-08-26 the component products
   were removed from those groups (on Loop's advice), which killed the duplicates at
   source, so the dedupe half was deleted along with the matching data-fc-plan-filter
   blocks in the sheet templates. Restore from git if components are ever put back in a
   pack's plan group. */

/* What this file actually does now:
   Tinker's header bubble (cart-icon.js) only re-renders on the theme's own
   shopify:cart:lines-update event, so cart changes made by Rebuy (drawer +/-,
   upsell Add buttons, item removal, double-add compensation) leave it stale
   until a page refresh. Rebuy fires rebuy:cart.change for EVERY cart change,
   including ajax adds it merely observed, so we sync the bubble from that. */
(function(){
  /** @type {ReturnType<typeof setTimeout>|undefined} */
  var t;
  /** @param {any} ev @returns {Promise<number>} */
  function itemCount(ev){
    try{
      var c=ev&&ev.detail&&ev.detail.cart&&ev.detail.cart.cart;
      if(c&&typeof c.item_count==='number')return Promise.resolve(c.item_count);
    }catch(e){}
    return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){return c.item_count});
  }
  document.addEventListener('rebuy:cart.change',/** @param {any} ev */function(ev){
    clearTimeout(t);
    t=setTimeout(function(){
      itemCount(ev).then(function(n){
        document.querySelectorAll('cart-icon').forEach(function(el){
          var icon=/** @type {any} */(el);
          if(typeof icon.renderCartBubble!=='function')return;
          var cur=icon.currentCartCount||0;
          if(cur!==n)icon.renderCartBubble(n,n>cur);
        });
      }).catch(function(){});
    },150);
  });
})();
